// define config for client here
export default {
   clientNameUseForApiRequest : "ancia",
   clientTagId : 1816
};